import { IconButton, type IconButtonProps, Stack, Switch, styled, switchClasses } from 'ui';

import { LANDSCAPE_CAMERA_HEADER_WIDTH, PORTRAIT_CAMERA_HEADER_HEIGHT, relativeZIndex } from '../../config';
export const Root = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isPortrait',
})<{ isPortrait: boolean }>(({ theme, isPortrait }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: isPortrait ? 'row' : 'column-reverse',
  gap: theme.spacing(1),
  height: isPortrait ? PORTRAIT_CAMERA_HEADER_HEIGHT : '100%',
  justifyContent: 'space-between',
  marginBottom: isPortrait ? 'auto' : undefined,
  paddingBottom: isPortrait ? theme.spacing(1) : theme.spacing(2),
  paddingLeft: isPortrait ? theme.spacing(2) : theme.spacing(1),
  paddingRight: isPortrait ? theme.spacing(2) : theme.spacing(1),
  paddingTop: isPortrait ? theme.spacing(2) : theme.spacing(2),
  position: 'fixed',
  width: isPortrait ? '100%' : LANDSCAPE_CAMERA_HEADER_WIDTH,
  zIndex: theme.zIndex.modal + relativeZIndex.toggleCameraButton,
}));

export const DarkIconButton = styled(IconButton)<IconButtonProps<'button'>>(({ theme }) => ({
  ':hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.layout[100],
}));

export const AutoCaptureSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== 'isPortrait',
})<{ isPortrait: boolean }>(({ isPortrait }) => ({
  [`.${switchClasses.input}`]: {
    left: 0,
  },
  transform: isPortrait ? undefined : 'rotate(270deg)',
}));
